import { computed } from 'vue'
import { injectService } from '@patsnap/tahiti-core/ioc/inject'
import { TrizService } from '@/domains/triz/services/triz-service';
import { createSharedComposable } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { Toast } from 'patsnap-biz';
import { ALL_MODULE_KEYS } from '@/domains/triz/constants/module-keys';

export const useTriz = createSharedComposable(() => {
    const route = useRoute()
    const trizService = injectService<TrizService>(TrizService)
    const { t } = useI18n()

    const currentModuleKey = computed(() => (route.query.module_key || '') as string)

    const currentVersion = computed(() => Number(route.query.version));

    const currentModuleData = computed(() => {
        if (!currentVersion.value || !currentModuleKey.value || !ALL_MODULE_KEYS[currentModuleKey.value]) return null;
        return trizService.getModuleData(currentVersion.value, currentModuleKey.value) ?? null;
    });

    function generateExtendIdea(triz_mind_id: string, idea_id: string, version: number) {
        return trizService.generateExtendIdea({ triz_mind_id, idea_id, version_number: version }).then(() => {
            Toast({
                type: 'success',
                message: t('step3.generateSimilarIdeasTip'),
                showClose: true,
            })
        })
    }

    function resetTrizData() {
        trizService.updateStepsData([])
    }

    function getSolutionDetail(ideaId: string) {
        return trizService.getSolutionDetail(ideaId)
    }

    function getSolutionImage(ideaId: string) {
        return trizService.getSolutionImage(ideaId)
    }

    function getSolutionVideo(ideaId: string) {
        return trizService.getSolutionVideo(ideaId)
    }

    function getSolutionFlowchart(ideaId: string) {
        return trizService.getSolutionFlowchart(ideaId)
    }

    function regenerateIdeas() {
        const triz_mind_id = route.params.triz_mind_id as string
        const source_version_number = currentVersion.value
        if (!triz_mind_id || !source_version_number) return Promise.reject(new Error('missing triz_mind_id or version'))
        return trizService.regenerateIdea({ triz_mind_id, source_version_number })
    }

    return {
        trizService,
        currentModuleData,
        currentVersion,
        currentModuleKey,
        generateExtendIdea,
        regenerateIdeas,
        resetTrizData,
        getSolutionDetail,
        getSolutionImage,
        getSolutionVideo,
        getSolutionFlowchart,
    }
})
